/**
 * ==========================================
 * Laravel Echo – Real-time konfiguráció
 * ==========================================
 *
 * Mire való?
 * Ez a fájl a Laravel broadcasting / websocket kliens (laravel-echo)
 * inicializálásáért felel a frontend oldalon.
 *
 * Működési mód:
 * - Reverb alapú valós idejű kommunikáció
 *   (értesítések, multi-tab szinkronizáció, live státusz frissítés stb.)
 * - vagy kikapcsolt / stub mód, ha a realtime funkció épp nincs használatban
 *
 * ENV kapcsoló:
 * - VITE_ECHO_ENABLED=true  → aktív Reverb kapcsolat
 * - VITE_ECHO_ENABLED=false → kikapcsolt / stub mód
 *
 * Fontos:
 * - ha VITE_ECHO_ENABLED=true, akkor a Reverb websocket szervernek is futnia kell
 * - indítás: php artisan reverb:start
 *
 * Megjegyzés:
 * - backend oldalon a Laravel broadcasting (Reverb) rendelkezésre áll
 * - frontend oldalon az Echo env kapcsoló alapján indul aktív vagy stub módban
 */

/*
 * FOR DEVELOPERS:
 *
 * Do not try to use custom names in the Laravel application, namely the function BroadcastAs()
 * The Laravel echo has an utterly stupid feature prefixing event names by a dot if the namespace "App\Events\"
 * was not found at the beginning of the string. As such, broadcasted custom names then get prefixed by their javascript
 * code making the entire thing obfuscated.
 * Providing an empty "namespace" config value at instantiating Echo - as a solution attempt - will then cut the first
 * character instead fixing this situation.
 *
 * Custom broadcast names could be listened with a dot prefix when registering a listener but who the hell will
 * remember about this rule?
 *
 * https://laravel.com/docs/11.x/broadcasting#namespaces
 *
 * https://github.com/laravel/echo/blob/master/src/channel/pusher-channel.ts#L80
 *
 * node_modules/laravel-echo/src/channel/pusher-channel.ts -> listenToAll()
 * let formattedEvent = event.startsWith(namespace) ? event.substring(namespace.length + 1) : '.' + event;
 *
 * Personally I find their idea utterly stupid this time.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useWebsocketTokenMap } from "./classes/WebsocketTokenMap.js";

/**
 * @type {WebsocketTokenMap}
 */
const TokenMap = useWebsocketTokenMap();

window.Pusher = Pusher;

const echoEnabled = String(import.meta.env.VITE_ECHO_ENABLED).toLowerCase() === 'true';

if (echoEnabled) {
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: frontendConfiguration.vueJs.echo.key,
        wsHost: frontendConfiguration.vueJs.echo.wsHost,
        wsPort: frontendConfiguration.vueJs.echo.wsPort,
        wssPort: frontendConfiguration.vueJs.echo.wssPort,
        forceTLS: frontendConfiguration.vueJs.echo.forceTLS,
        enabledTransports: ['ws', 'wss'],
        authorizer: (channel, options) => {
            return {
                authorize: (socketId, callback) => {
                    axios.post('/broadcasting/auth', {
                        socket_id: socketId,
                        channel_name: channel.name
                    }).then(response => {
                        TokenMap.set(channel.name, response.data.token);
                        callback(false, response.data);
                    }).catch(error => {
                        console.error('Websocket connection failed');
                        console.log(error);
                        callback(true, error);
                    });
                }
            };
        },
    });

    console.info('🟢 Echo: REVERB mód AKTÍV');
} else {
    window.Echo = new Echo({
        broadcaster: 'null',
    });

    console.info('⚪ Echo: STUB mód (kikapcsolva)');
}